import { Box } from 'grommet';
import { observer } from 'mobx-react-lite';
import { AddNewButton } from '../../AddNewButton';
import { useEstimateStore } from '@talon/web/src/context';

export interface IUsageEstimateFooterProps {
  addEstimateItem: () => void | Promise<void>;
}

export const UsageEstimateFooter = observer(({ addEstimateItem }: IUsageEstimateFooterProps) => {
  /** Context **/
  const estimateStore = useEstimateStore();

  /** Computed **/
  const canEdit = estimateStore.canEditCurrent;

  /** Render **/
  return (
    <Box
      gap="small"
      pad={{ vertical: 'small', horizontal: 'medium' }}
      background="white"
      border={{ side: 'top', color: 'border-divider' }}
    >
      {canEdit && <Box width="15%" pad={{ vertical: 'xsmall' }}>
        <AddNewButton plain label="Add item" tipText="Add estimate item" onClick={() => addEstimateItem()} />
      </Box>}
    </Box>
  );
});
